export default "__VITE_ASSET__c8583040__"